import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-alert-popup',
    templateUrl: './alert-popup.component.html',
    styleUrls: ['./alert-popup.component.scss'],
    standalone: false
})
export class AlertPopupComponent implements OnInit {

	message = '';
	constructor(private dialogRef: MatDialogRef<AlertPopupComponent>,
							@Inject(MAT_DIALOG_DATA) data:any) {
		this.message = data.message;
	}

  ngOnInit(): void {
  }

	cancel() {
		this.dialogRef.close(false);
	}

}
